import React from "react";

export function EditorToolsBottomLeft() {
    return (
        <div className="editor-tools editor-tools-bottom-left">

        </div>
    );
}
